import { leadership } from "../data/leadership";
import { useReveal } from "../hooks/useReveal";
import { useI18n } from "../i18n/LanguageContext";
import { Icon } from "./Icon";
import { SectionHead } from "./SectionHead";
import styles from "./Leadership.module.css";

export function Leadership() {
  const { t, ui } = useI18n();
  const reveal = useReveal();

  return (
    <section id="expertise" className={`section band ${styles.section}`}>
      <div className="container">
        <SectionHead
          eyebrow={ui.leadership.eyebrow}
          title={ui.leadership.title}
          sub={ui.leadership.sub}
        />

        <div className={styles.grid} ref={reveal}>
          {leadership.map((card) => (
            <article key={card.id} className={styles.card}>
              <span className={styles.icon}>
                <Icon name={card.icon} size={24} />
              </span>
              <h3 className={styles.title}>{t(card.title)}</h3>
              <p className={styles.text}>{t(card.text)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
